// Returns the content set for the active language. Spanish overrides are merged
// over the English exports; anything not translated falls back to English.
import * as EN from "@/lib/data";
import { ES } from "@/i18n/content.es";
import { useI18n } from "@/i18n";

export function useContent() {
  const { lang } = useI18n();
  if (lang !== "es") return EN;
  return { ...EN, ...ES };
}
